import { render, staticRenderFns } from "./ColClear.vue?vue&type=template&id=2f05faac&"
import script from "./ColClear.vue?vue&type=script&lang=js&"
export * from "./ColClear.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports